<template>
    <main id="LmUsersNewOrEdit" class="wrapper-content w-100">
        <LmComponentLoading v-if="isLoading" fixed />

        <h1>Modificar Contraseña</h1>
        <LmForm ref="lmFormRef" >
            <b-col cols="12" class="col-lg-6 p-0">
                <LmPassword
                    @enter="saveNewPassword"
                    v-model="form.password"
                    :v="$v.form.password"
                    label="Nueva contraseña"
                    />
            </b-col>
            <b-col cols="12" class="col-lg-6 p-0">
                <LmPassword
                    @enter="saveNewPassword"
                    v-model="form.password_again"
                    :v="$v.form.password_again"
                    :label="$t('password_again')"
                />
            </b-col>
        </LmForm>

        <!-- Action Buttons -->
        <div class="buttons">
            <LmButton
                :value="$t('cancel')"
                type="button"
                buttonClass="btn-secondary"
                @click="onCancel()"
            />
            <LmButton
                :value="$t('save')"
                type="button"
                buttonClass="btn-primary"
                @click="saveNewPassword()"
            />
      </div>
    </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmForm from '@/components/form/LmForm'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmPassword,
    LmEmailInput,
    LmTreeSelect
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {
        password: '',
        password_again: ''
      },
      isLoading: false
    }
  },
  validations: {
    form: {
      password: {
        required
      },
      password_again: {
        sameAspassword: sameAs('password'),
        required
      }
    }
  },
  methods: {
    async saveNewPassword () {
      this.validatePasswords(this.form)
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        try {
          await commonsApi.axiosPutWrapper(`/users/password/reset/${this.$route?.params?.id}`, this.form)
          this.lmToastSuccessMessage(`Se modificó la contraseña correctamente.`, 'Contraseña modificada')
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        } catch (error) {
          console.log(error)
        }
      }
    },
    resetPasswordModal () {
      this.form.password = ''
      this.form.password = ''
      this.form.password_again = ''
      this.$v.form.$reset()
    },
    // eslint-disable-next-line
    validatePasswords ({ password, password_again }) {
      // eslint-disable-next-line
      if (password !== password_again) {
        this.lmToastDangerMessage(this.$t(`Las contraseñas deben ser iguales`), 'Error')
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    }
  }
}

</script>

<style>
.button {
  margin-top: 35px;
}
</style>
